import { IHttpResponse, IObject } from "@/objects/Index";
import request from "./request";
import { getCache } from "./cache";
import { Authorization } from "@/constants/cacheKey";

/**
 * 常用CRUD
 */
export default {
  /**
   * 删除
   * @param path
   * @param params
   * @returns
   */
  delete(path: string, params?: IObject, headers?: IObject): Promise<IHttpResponse> {
    const token = getCache(Authorization)
    headers = {
      "Authorization": token ? `Bearer ${token.token}` : '',
      ...headers
    }
    return request({
      url: path,
      data: params,
      headers,
      method: "DELETE"
    });
  },
  get(path: string, params?: IObject, headers?: IObject): Promise<IHttpResponse> {
    const token = getCache(Authorization)
    headers = {
      "Authorization": token ? `Bearer ${token.token}` : '',
      ...headers
    }
    return new Promise((resolve, reject) => {
      request({
        url: path,
        params,
        headers,
        method: "GET"
      })
        .then(resolve)
        .catch((error) => {
          if (error !== "-999") {
            reject(error);
          }
        });
    });
  },
  put(path: string, params?: IObject, headers?: IObject): Promise<IHttpResponse> {
    const token = getCache(Authorization)
    return request({
      url: path,
      data: params,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Authorization": token ? `Bearer ${token.token}` : '',
        ...headers
      },
      method: "PUT"
    });
  },
  /**
   * 通用post方法
   * @param path
   * @param body
   * @returns
   */
  post(path: string, body?: IObject, headers?: IObject): Promise<IHttpResponse> {
    const token = getCache(Authorization)
    return request({
      url: path,
      method: "post",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Authorization": token ? `Bearer ${token.token}` : '',
        ...headers
      },
      data: body
    });
  }
};
